import {
  ApiCartChangeCartBirthDateFailedAction,
  ApiCartChangeCartBirthDateSucceededAction,
  apiCartChangeCartBirthDateFailedType,
  apiCartChangeCartBirthDateRequested,
  apiCartChangeCartBirthDateSucceededType
} from '../../api/cart/changeCartBirthDateApi';
import {
  ChangeCurrentCartBirthDateRequestedAction,
  changeCurrentCartBirthDateFailed,
  changeCurrentCartBirthDateSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { ChangeCartBirthDateResult } from '../../../graphql/cart/changeCartBirthDate';
import { CustomOrderType } from '../../carts/CustomOrderType';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartBirthDateSaga({
  payload: { actionId: requestedActionId, birthDate, customOrderType }
}: ChangeCurrentCartBirthDateRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartChangeCartBirthDateRequested({
      actionId,
      birthDate,
      customOrderType,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId, customOrderType);
}

function* actionsLoop(
  actionId: number,
  requestedActionId: number,
  customOrderType: CustomOrderType
): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartChangeCartBirthDateSucceededAction>(
        apiCartChangeCartBirthDateSucceededType
      ),
      failed: take<ApiCartChangeCartBirthDateFailedAction>(apiCartChangeCartBirthDateFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const { cart, error }: ChangeCartBirthDateResult = succeeded.payload.result;
        if (cart === null || error !== null) {
          yield* put(
            changeCurrentCartBirthDateFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartBirthDateSucceeded({
              cart: convertCartToStateCart(cart),
              customOrderType,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartBirthDateFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartBirthDateSaga;
